// extracted by mini-css-extract-plugin
module.exports = {"boxItem":"main-hero_boxItem__TGenG","popIn":"main-hero_popIn__WfrPx"};